export const css = {
    root: '_1s_m7O43',
    heading: 'DSspX8m3',
    row: 'PSSlVK4c',
    product: '_3NFj47uR',
    primary: '_1w3qc9UQ',
    secondary: '_2sBq9s0j',
    sticky: '_1Vl3FIcA',
    leading: 'L15QC42x',
    title: '_3Yq8Y2jO',
    actions: '_2si10OBp',
    action: '_3BEodsdp',
    trailing: '_2HM3Ezey',
    spacer: '_2uHtwKk_',
    hamburgerWrapper: '_3jn6Fip3',
    hamburger: '_1uO3Kvpk',
    hamburgerText: '_14QZp4XL',
    hamburgerMenu: '_1VUwGn_4',
    hamburgerMenuItem: '_12pSG6lB',
    quizSelect: '_3xAvWyDn',
    quizSelectBlock: '_1C04itXD',
    hideCountdownBlock: '_11sKFsb3',
    quizSelectChoice: '_1JGAwzFZ',
    selectFadeOut: 'inUPPilF',
    quizSelectHidden: 'N_jACfOn',
    examCalendar: '_26aDjmqy',
    home: '_3aPRAUwh',
    divider: 'kX5Kxs_o',
    ' _key': 'lcc-app/heading'
};
export default css;
